<template>
    <section class="profile-update-wrapper auth_container">
        <div class="container">
            <div class="form_container">
                <v-row>
                    <v-col cols="12" lg="6">
                        <div class="auth_image_container">
                            <div class="auth-group-1">
                                <img src="@/assets/images/group-1.png" />
                            </div>
                            <div class="auth-main-image">
                                <img src="@/assets/images/laptop.png" />
                            </div>
                            <div class="auth-group-2">
                                <img src="@/assets/images/group-2.png" />
                            </div>
                        </div>
                    </v-col>
                    <v-col cols="12" lg="6">
                        <div class="form_header_part">
                            <div class="form_header_title">
                                Profile Update
                            </div>
                        </div>
                        <v-card flat class="pt-0 pb-5 px-0">
                            <v-card-text class="mt-0 pl-5">
                                <v-form class="profile-form" @submit.prevent="profileupdate()" style="max-width: 700px; width: 100%;">
                                    <v-row align="center">
                                        <!-- <v-col cols="12" class="d-flex align-center">
                                            <div class="mr-5">Profile Picture</div>
                                            <figure class="profile__pic">
                                                <v-btn elevation="0" class="btn-avatar">
                                                    <img :src="image" >
                                                    <span 
                                                        class="profile__pic__placeholder"
                                                        v-if="image === null"
                                                    >
                                                        <v-icon large>mdi-plus</v-icon><br>
                                                        Add Profile <br>Picture
                                                    </span>
                                                    <v-file-input
                                                        filled
                                                        class="profile__pic__upload"
                                                        prepend-icon="mdi-camera"
                                                        v-model="profile_pic"
                                                        @change="profilePic($event)"
                                                    ></v-file-input>
                                                </v-btn>
                                            </figure>
                                        </v-col> -->
                                        <v-col cols="12">
                                            <v-text-field
                                                outlined
                                                filled
                                                dense
                                                v-model="formData.first_name"
                                                :error-messages="first_nameErrors"
                                                prepend-icon="mdi-account-circle-outline"
                                                label="First Name"
                                                @input="$v.formData.first_name.$touch()"
                                                @blur="$v.formData.first_name.$touch()"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-text-field
                                                outlined
                                                filled
                                                dense
                                                v-model="formData.last_name"
                                                :error-messages="last_nameErrors"
                                                prepend-icon="mdi-account-circle-outline"
                                                label="Last Name"
                                                @input="$v.formData.last_name.$touch()"
                                                @blur="$v.formData.last_name.$touch()"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-text-field
                                                outlined
                                                filled
                                                dense
                                                type="email"
                                                v-model="formData.email"
                                                :error-messages="emailErrors"
                                                prepend-icon="mdi-email"
                                                label="Email Address"
                                                @input="$v.formData.email.$touch()"
                                                @blur="$v.formData.email.$touch()"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-text-field
                                                outlined
                                                filled
                                                dense
                                                v-model="formData.phone_number"
                                                :error-messages="phoneErrors"
                                                prepend-icon="mdi-cellphone-iphone"
                                                label="Phone Number"
                                                @input="$v.formData.phone_number.$touch()"
                                                @blur="$v.formData.phone_number.$touch()"
                                            ></v-text-field>
                                            <v-btn
                                                type="button"
                                                :loading="loading"
                                                :disabled="loading"
                                                @click.prevent="profileupdate(), loader = 'loading'"
                                                class="btn big_blue_button mt-3"
                                                id="log-in"
                                            >
                                                Update
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-card-text>
                            
                        </v-card>

                    </v-col>
                </v-row>

            </div>
        </div>
    </section>
</template>

<script>

import { validationMixin } from 'vuelidate'
import { required, email} from 'vuelidate/lib/validators'
export default {
    name: 'ProfileUpdate',
    data:()=>({
        formData: {},
        validation: {},
        profile_pic: null,
        image: null,
        loader: null,
        loading: false,
    }),
    mixins: [validationMixin],
    validations: {
        formData: {
            first_name: {
                required
            },
            last_name: {
                required
            },
            email: {
                required,
                email
            },
            phone_number: {
                required,
            }
        } 
    },
    computed: {
        emailErrors() {
        const errors = []
        if(!this.$v.formData.email.$dirty) return errors
        !this.$v.formData.email.email && errors.push('Must be valid e-mail')
        !this.$v.formData.email.required && errors.push('E-mail is required')
        return errors
        },
        first_nameErrors() {
        const errors = []
        if(!this.$v.formData.first_name.$dirty) return errors
        !this.$v.formData.first_name.required && errors.push('First Name is required')
        return errors
        },
        last_nameErrors() {
        const errors = []
        if(!this.$v.formData.last_name.$dirty) return errors
        !this.$v.formData.last_name.required && errors.push('Last Name is required')
        return errors
        },
        phoneErrors() {
        const errors = []
        if(!this.$v.formData.phone_number.$dirty) return errors
        !this.$v.formData.phone_number.required && errors.push('Phone Number is required')
        return errors
        },
    },
    async mounted () {
        await this.$api.get('/authuser/get-profile/').then(res => {
            this.formData = res;
            
            if(res.profile_pic) {
                file = res.profile_pic
                self.image = URL.createObjectURL(res.profile_pic)
                console.log(this.image);
            }
        })
    },

    methods: {
        profilePic($event) {
            let file = $event;
            let self = this;
            self.image = URL.createObjectURL(file);
            self.profile_pic.push(file);
        },
        async profileupdate() {
            
            this.$v.$touch();
            // let formData = new FormData

            // if(this.image) {
            //     formData.append('profile_pic', this.profile_pic)
            // }

            // formData.append('first_name', this.formData.first_name)
            // formData.append('last_name', this.formData.last_name)
            // formData.append('email', this.formData.email)
            // formData.append('phone_number', this.formData.phone_number)

            await this.$api.post('/authuser/update-profile/', this.formData);
            this.$router.push('/profile')
            location.reload();
        }
    },
    watch: {
      loader () {
        const l = this.loader
        this[l] = !this[l]

        setTimeout(() => (this[l] = false), 3000)

        this.loader = null
      },
    },
}
</script>

<style>

</style>